import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import knap from './assets/knap.png'
import ap from './assets/ap.png'
import fn from './assets/fn.png'
import cc from './assets/cc.jpg'
import inter from './assets/inter.jpg'
import paren from './assets/paren.png'
import miss from './assets/mis.jfif'
import island from './assets/island.jfif'
import revLL from './assets/revLL.png'
import gat from './assets/gat.jpeg'
import pangrams from './assets/pangrams.png'
import close from './assets/close.png'
import histo from './assets/histo.png'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  
  <div class="card 1">
    <div class="card_image">
      <img src={gat} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Group Anagrams Together</p>
        <NavLink to='/category/Snapdeal Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={pangrams} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Pangram Strings</p>
      <NavLink to='/category/Snapdeal Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={knap} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>0 – 1 Knapsack Problem</p>
      <NavLink to='/category/Snapdeal Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={ap} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Longest Arithmetic Progression</p>
      <NavLink to='/category/Snapdeal Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={fn} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Next greater number set digits</p>
        <NavLink to='/category/Snapdeal Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={cc} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Number of Coins</p>
      <NavLink to='/category/Snapdeal Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={inter} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Check If two Line segments Intersect</p>
      <NavLink to='/category/Snapdeal Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={close} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Two numbers with sum closest to zero</p>
      <NavLink to='/category/Snapdeal Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={paren} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Parenthesis Checker</p>
        <NavLink to='/category/Snapdeal Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={histo} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Maximum Rectangular Area in a Histogram</p>
      <NavLink to='/category/Snapdeal Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={miss} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Smallest Positive missing number</p>
      <NavLink to='/category/Snapdeal Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={island} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find the number of islands</p>
      <NavLink to='/category/Snapdeal Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={revLL} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse a Linked List in groups of given size</p>
        <NavLink to='/category/Snapdeal Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    
    </div>
        </div>
    )
}

export default Ind
